import { FC, MouseEventHandler } from 'react';
import { DriveItem } from '@microsoft/microsoft-graph-types';
import { FiDownload } from 'react-icons/fi';
import strings from '../../services/common.translations';
import { useFetchItem } from '../../services/graph/hooks/onedrive';

interface Props {
  file: DriveItem;
}

export const DocumentDownloadButton: FC<Props> = ({ file }) => {
  const fetch = useFetchItem(file.id || '');

  const getUrl = (item: DriveItem) => {
    //The ms graph types don't seem to ever include the download URL, even though we're getting it from the API.
    //Not sure if there's a smarter solution than casting file to any and getting it out, but this works.

    return (item as any)['@microsoft.graph.downloadUrl']
  }
  
  const onDownload: MouseEventHandler = async event => {
    event.preventDefault();

    const url = getUrl(file) || getUrl(await fetch());

    if (!url) {
      throw Error("Could not get download URL")
    }

    window.location.assign(url);
  };

  return (
    <button
      type="button"
      className="w-full bg-primary-std p-2 border-t flex items-center justify-center gap-2"
      onClick={onDownload}
    >
      <FiDownload className="h-5 w-5" />
      <span>{strings.common.download}</span>
    </button>
  );
};
